import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import i18next from 'i18next';
import { IsEnglish } from '../../utils/language';
import { toDisplayDecimal } from '../../utils';
import styles from '../../styles/timesheet.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        
    },
    divList: {
        
    },
    spanNewRow: {
        display: 'table'
    },
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    },
    konekCard: {
        
    }
}));

export default function TimesheetSummaryDetail(props) {
    const classes = useStyles();

    const { data } = props;

    useEffect(() => {

    }, []);

    return (
        <div style={{ width: '-webkit-fill-available' }}>
            <div className={classes.konekCard}>
                <div className={classes.divList}>
                    {data != null && data.length > 0 && data.map((obj, index) =>
                        <React.Fragment key={index}>
                            <ListItem key={index} className="listItem">
                                <ListItemText primary={
                                    <React.Fragment>
                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t('timesheet:summary-detail.subcode')}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{obj.sc}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t('timesheet:summary-detail.description')}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{IsEnglish() ? obj.scEn : obj.scFr}</span>
                                        </div>

                                        <div>
                                            <span className={classes.spanLabel}>{i18next.t('timesheet:summary-detail.time')}{i18next.t('common:labelSeparator')}</span>
                                            <span className={classes.spanValue}>{toDisplayDecimal(obj.duration)}</span>
                                        </div>
                                    </React.Fragment>
                                } />
                            </ListItem>
                        </React.Fragment>
                    )}
                </div>
            </div>
        </div>
    );
}